import React from 'react';

const UnauthenticatedComponent: React.FC = () => (
  <div style={{ textAlign: 'center', marginTop: '2rem', color: 'red' }}>
    <h2>Authentication failed or was cancelled.</h2>
    <p>Please try signing in again.</p>
  </div>
);

export default UnauthenticatedComponent;
